import axios from 'axios'
import store from '../state/store'
import Vue from 'vue'
import router from '@/router'

axios.defaults.baseURL = process.env.VUE_APP_API_SERVER

axios.interceptors.request.use(
  async config => {
    // do not intercept graph API calls
    if (config.url.includes('graph.microsoft.com')) {
      return config
    }
    if (store.state.userInfo.accessToken === '') {
      await refreshToken(store)
    }
    config.headers['Authorization'] = 'Bearer ' + store.state.userInfo.accessToken
    return config
  },
  error => {
    router.push('/login')
    /*  const status = error.response ? error.response.status : null
    if (status === 401) {
      return refreshToken(store).then(() => {
        error.config.headers['Authorization'] = 'Bearer ' + store.state.userInfo.accessToken
        return axios.request(error.config)
      })
    } */
    return Promise.reject(error)
  })

function refreshToken (store) {
  store.commit('setRefreshingState', true)
  const refreshingCall = store.dispatch('getAccessToken', Vue.prototype.$msalInstance).then(() => {
    store.commit('setRefreshingState', false)
    store.commit('setRefreshingCall', undefined)
    return Promise.resolve(true)
  })
  store.commit('setRefreshingCall', refreshingCall)
  return refreshingCall
}

export default axios
